import React from 'react';
import { Header } from '../components/site/Header';
import { Footer } from '../components/site/Footer';
import { Hero } from '../components/sections/Hero';
import { Services } from '../components/sections/Services';
import { Steps } from '../components/sections/Steps';
import { About } from '../components/sections/About';
import { ContactSection } from '../components/sections/ContactSection';
export function PublicSite() {
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-1784" data-mp="j9a2kj10y2c1">
      <Header data-id="element-1785" data-mp="f7y8o1b4auy1" />
      <main className="flex-1" data-id="element-1786" data-mp="f99d83ce06q7">
        <Hero data-id="element-1787" data-mp="fab0r7alalot" />
        {/* Personen bag firmaet kommer tidligt — tillid før detaljer. */}
        <About data-id="element-1788" data-mp="afnab2w0zh7l" />
        <Services data-id="element-1789" data-mp="af54bejk9omh" />
        <Steps data-id="element-1790" data-mp="5in1wlbpe2db" />
        <ContactSection data-id="element-1791" data-mp="5j6ls7kwz0tz" />
      </main>
      <Footer data-id="element-1792" data-mp="5hvfo13zxgzp" />
    </div>;
}